import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import classname from 'classname';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import PostbackLogTable from '../table/postback-log';
import Filters from '../../../shared/filters/main';
import Calendar from '../../../shared/calendar/main';
import InputField from '../../../shared/form-elements/input';

lessRequire('modules/streams/components/stream-form/part-postback-log.less');

const PartLog = props => {
	const { active, list } = props.sections;
	const { fetchPostbacks, calendarPostbackListInit, calendarPostbackListToggle,
		calendarPostbackListChange, calendarPostbackListApply, calendar, downloadPostbacks
	} = props;
	const className = classname({
		'stream-form__postback-log': true,
		'active': active === list.postbacklog
	});

	return (
		<div className={className}>
			<div className="postback__table-tools">
				<div className="postback__table-tools__filtes-search">
					<Filters {...props}/>
					<InputField
						className='postback__table-postback-search'
						placeholder={props.intl('Поиск по id конверсии')}
						input={{
							value: props.postbackSearch,
							name: 'postbackSearch'
						}}
						autoComplete='off'
						meta={{
							active: true
						}}
						onChange={(e) => props.setPostbackSearch(e.target.value)}
					/>
				</div>
				<div className="tools--buttons">
					<Calendar
						{...calendar}
						onInit={calendarPostbackListInit}
						onToggle={calendarPostbackListToggle}
						onChange={calendarPostbackListChange}
						onApply={calendarPostbackListApply}
					/>
					<div className="postback-buttons__container">
						<button className="submit-btn" onClick={fetchPostbacks}></button>
						<button className="save-btn" onClick={downloadPostbacks}></button>
					</div>
				</div>
			</div>
			{!!props.postBackLogData && !_isEmpty(props.postBackLogData[0]) &&
				<PostbackLogTable
					isShowMoreVisible={props.isShowMoreVisible}
					showMore={props.showMore}
					rows={props.postBackLogData}
					intl={props.intl}
				/>
			}
		</div>
	);
};

PartLog.propTypes = {
	sections: PropTypes.object,
	postBackLogData: PropTypes.array,
	isShowMoreVisible: PropTypes.bool,
	showMore: PropTypes.func,
	intl: PropTypes.func
};

export default PartLog;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/stream-form/part-postback-log.js